import axios from 'axios';
import md5 from "js-md5";
import { Toast } from 'mand-mobile';
import { baseurl } from '@/config/url.js';
import storage from './storage.js'
//sign加密
export function mdKey5(obj) {
  obj.timestamp = new Date().getTime();
  let key = 'KUdnTJaVlJYnrJeKQRWagXiZdaHPDit6';
  let str = '';
  var keys = Object.keys(obj).sort();

  for (let i = 0; i < keys.length; i++) {
    str += `${keys[i]}=${obj[keys[i]]}&`
  }
  str += 'key=' + key;
  console.log(str,2)
  return {
    ...obj,
    signature: md5(str)
  }
}
axios.interceptors.request.use(function (config) {

  // 在发送请求之前做些什么
  if (config.params) { //get
    config.params = mdKey5(config.params)
  }
  if (config.data) { //post
    config.data = mdKey5(config.data)
  }

  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
axios.interceptors.response.use((res) => {
  if (res.data.code == '200') {
    return Promise.resolve(res.data);
  } else {
    Toast.info(res.data.msg,1500);
    return Promise.reject(res.data);
  }
}, (error) => {
  //404等问题可以在这里处理
  Toast.failed(error,1500);
  return Promise.reject(error);
});
axios.defaults.baseURL = baseurl;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
let token = storage.getItem("token");
console.log(token)
token && setHeardTokenId(token);
export function setHeardTokenId(tokenId) {
  axios.defaults.headers.Authorization = tokenId
}
export default axios;



